import Cookies from "js-cookie";

const baseUrl = "https://server.gefmart.com/api/"; // live
// const baseUrl = "https://debugserver.gefmart.com/api/"; // debug
// const baseUrl = "http://localhost:3002/api/"; // local

const accessToken = Cookies.get("gefmartUserToken");

// category
const getAllCategoriesUrl = `${baseUrl}get-all-categories`;
const subCategoriesUrl = `${baseUrl}sub-categories-of-category/`;

// brand
const getAllBrandsUrl = `${baseUrl}get-all-brands`;

// blogs
const getAllBlogsUrl = `${baseUrl}get-all-blogs`;

// marketplace
const marketPlaceByCategoryUrl = `${baseUrl}get-all-marketplaces-categories`;
const getAllMarketPlaceListings = `${baseUrl}get-all-marketplaces`;
const getMyMarketplacesUrl = `${baseUrl}get-my-marketplaces`;
const getSingleMarketplaceUrl = `${baseUrl}marketplaces/`;
const deleteMarketPlaceUrl = `${baseUrl}delete-marketplace/`;

// user
const getUserDetailsUrl = `${baseUrl}users/`;

// products
const getProductsUrl = `${baseUrl}get-all-products/`;

// order
const ordersUrl = `${baseUrl}orders/`;
const changeOrderStatusUrl = `${baseUrl}change-orders-status/`;

// cart
const cartUrl = `${baseUrl}carts/`;

export {
  baseUrl,
  marketPlaceByCategoryUrl,
  getAllMarketPlaceListings,
  getAllCategoriesUrl,
  getAllBrandsUrl,
  accessToken,
  getUserDetailsUrl,
  getAllBlogsUrl,
  getMyMarketplacesUrl,
  subCategoriesUrl,
  getSingleMarketplaceUrl,
  getProductsUrl,
  ordersUrl,
  changeOrderStatusUrl,
  cartUrl,
  deleteMarketPlaceUrl,
};
